export default __webpack_public_path__ + "static/media/812.e364b365.png";